const React = require("react");
const createReactClass = require("create-react-class");
const {augmentHOCWrapper} = require("../util/HOCUtil");

// withDelayedRender(Component, options) returns a component which renders the
// same thing but slightly delays the initial render. This is used as a hack to
// fix components which animate in componentDidMount; these animations just
// don't seem to work without this. Available options are:
// - delay: Milliseconds for the setTimeout call. Default 0.
// - condition: Optional function which takes the props and returns a boolean.
//   The delay only happens if this function returns true.

module.exports = augmentHOCWrapper(function(Component, options) {
	options = options || {};
	const delay = options.delay || 0;
	const condition = options.condition || (() => true);

	return createReactClass({
		displayName: "Delayed:" + Component.displayName,

		getInitialState: function() {
			return {
				isRendering: !condition(this.props),
			};
		},

		componentDidMount: function() {
			setTimeout(() => {
				if (this.isUnmounted || this.state.isRendering) {
					return;
				}
				this.setState({isRendering: true});
			}, delay);
		},

		componentWillUnmount: function() {
			this.isUnmounted = true;
		},

		render: function() {
			if (!this.state.isRendering) {
				return null;
			}
			return <Component {...this.props} />;
		},
	});
});
